import { OtherCustomQuotationTypeEnum } from "@/constants/enums/otherCustomQuotationType.enum";
import { Badge } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useOtherCustomQuotationTypeLabels } from "@/hooks/useEnumLabels";

export const CustomQuotationOtherTypeBadge = ({
  type,
}: {
  type: OtherCustomQuotationTypeEnum | undefined;
}) => {
  const otherCustomQuotationTypeLabels = useOtherCustomQuotationTypeLabels();
  const { t } = useTranslation("shared");
  switch (type) {
    case OtherCustomQuotationTypeEnum.SOUS_DOUANE:
      return (
        <Badge
          variant="standard"
          className="w-fit rounded-xl border border-purple-200 bg-purple-50 px-2 py-0.5 text-sm font-medium text-purple-700"
        >
          {otherCustomQuotationTypeLabels.SOUS_DOUANE}
        </Badge>
      );
    case OtherCustomQuotationTypeEnum.T1_T2:
      return (
        <Badge
          variant="standard"
          className="w-fit rounded-xl border border-indigo-200 bg-indigo-50 px-2 py-0.5 text-sm font-medium text-indigo-700"
        >
          {otherCustomQuotationTypeLabels.T1_T2}
        </Badge>
      );
    case OtherCustomQuotationTypeEnum.RFSE:
      return (
        <Badge
          variant="standard"
          className="w-fit rounded-xl border border-purple-200 bg-purple-50 px-2 py-0.5 text-sm font-medium text-purple-700"
        >
          {otherCustomQuotationTypeLabels.RFSE}
        </Badge>
      );
    case OtherCustomQuotationTypeEnum.DEFAULT:
      return (
        <Badge
          variant="standard"
          className="w-fit rounded-xl border border-gray-200 bg-gray-50 px-2 py-0.5 text-sm font-medium text-gray-700"
        >
          {otherCustomQuotationTypeLabels.DEFAULT}
        </Badge>
      );
    case OtherCustomQuotationTypeEnum.DAE:
      return (
        <Badge
          variant="standard"
          className="w-fit rounded-xl border border-gray-200 bg-gray-50 px-2 py-0.5 text-sm font-medium text-gray-700"
        >
          {otherCustomQuotationTypeLabels.DAE}
        </Badge>
      );
    case OtherCustomQuotationTypeEnum.RP_FISC_PART:
      return (
        <Badge
          variant="standard"
          className="w-fit rounded-xl border border-gray-200 bg-gray-50 px-2 py-0.5 text-sm font-medium text-gray-700"
        >
          {otherCustomQuotationTypeLabels.RP_FISC_PART}
        </Badge>
      );
    case OtherCustomQuotationTypeEnum.RP_FISC_PRO:
      return (
        <Badge
          variant="standard"
          className="w-fit rounded-xl border border-gray-200 bg-gray-50 px-2 py-0.5 text-sm font-medium text-gray-700"
        >
          {otherCustomQuotationTypeLabels.RP_FISC_PRO}
        </Badge>
      );
    default:
      // const _exhaustiveCheck: never = type;
      return (
        <Badge
          variant="standard"
          className="w-fit rounded-xl border border-gray-200 bg-gray-50 px-2 py-0.5 text-sm font-medium text-gray-700"
        >
          {t("badges.unknownValue")}
        </Badge>
      );
  }
};
